import AdicionarPacientes from '../components/Pacientes/AdicionarPaciente.vue'

let routes = {
    path: '/adicionar-paciente',
    component: resolve => require(['../components/layout/HeaderAndLeftNavBar.vue'], resolve),
    children: [
        {
            path: '/adicionar-paciente',
            name: 'AdicionarPacientes',
            component: AdicionarPacientes
        },
    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/adicionar-paciente.js